import type { ApiErrorCode } from "@69ly/shared";

/** An error from the API, with its stable code for the screens to translate. */
export class ApiFailure extends Error {
  readonly status: number;
  readonly code: ApiErrorCode | "network" | "internal";
  constructor(status: number, code: ApiFailure["code"], message: string) {
    super(message);
    this.status = status;
    this.code = code;
  }
}

type Method = "GET" | "POST" | "PUT" | "PATCH" | "DELETE";

export async function api<T>(method: Method, path: string, body?: unknown): Promise<T> {
  let res: Response;
  try {
    res = await fetch(`/api${path}`, {
      method,
      credentials: "same-origin",
      headers: body !== undefined ? { "content-type": "application/json" } : undefined,
      body: body !== undefined ? JSON.stringify(body) : undefined,
    });
  } catch {
    throw new ApiFailure(0, "network", "Network error");
  }
  if (res.status === 204) return undefined as T;
  const data = (await res.json().catch(() => null)) as { code?: ApiFailure["code"]; message?: string } | null;
  if (!res.ok) throw new ApiFailure(res.status, data?.code ?? "internal", data?.message ?? res.statusText);
  return data as T;
}

/** Address of the Steam sign-in, coming back to `next` afterwards. */
export const steamSignInUrl = (next: string) => `/api/auth/steam?next=${encodeURIComponent(next)}`;
